<template>
  <div class="page-container">
    <Filter ref="filterRef" :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="taskName" :label="$t('collect.messagelist.taskName')" />
      <el-table-column prop="programName" :label="$t('collect.messagelist.programName')" />
      <el-table-column prop="robotSN" :label="$t('activity.packetjoin.robotCode')"/>
      <el-table-column :label="$t('collect.messagelist.fileName')" prop="decodeFileName" width="500">
        <template #default="scope">
          <el-button v-show="authList.includes('healthTaskReport:download')" type="text" @click="exportReportData(scope.row)" style="white-space: normal;word-wrap: break-word;overflow-wrap: break-word;text-align: left;">{{ scope.row.decodeFileName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="uploadTime" :label="$t('collect.messagelist.uploadTime')" width="180"/>
    </Table>
  </div>
</template>

<script>
import { request } from '@/utils/request'
import { downloadFile } from "@/utils/request";
import { common } from '../../common/mixin'
import Table from '@/components/table/index'
import Filter from '@/components/table/filter'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  data () {
    const route = useRoute()
    const taskName = route.query.taskName
    const robotSN = route.query.robotSN
    return {
      params: [
        {
          key: 'taskName',
          value: taskName,
          label: this.$t('collect.messagelist.taskName')
        },
        {
          key: 'programName',
          value: '',
          label: this.$t('collect.messagelist.programName')
        },
        {
          key: 'robotSN',
          value: robotSN,
          label: this.$t('activity.packetjoin.robotCode')
        },
        {
          type: 'Date',
          key: 'timeRange',
          value: taskName == undefined ? [
            dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
            dayjs().format('YYYY-MM-DD') + ' 23:59:59'
          ] : [],
          label: this.$t('collect.messagelist.uploadTime'),
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': this.$t('activity.detail.to'),
            'start-placeholder': this.$t('activity.list.startDate'),
            'end-placeholder': this.$t('activity.list.endDate'),
            'default-time': [
              new Date(2000, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          }
        }
      ],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      authList: JSON.parse(window.localStorage.getItem('authList'))
    }
  },
  created () {},
  mounted () {
    this.$refs.filterRef?.searchData()
  },
  methods: {
    getData () {
      console.log(this.query)
      request('getReportList', {
        ...this.query,
        page: this.page,
        size: this.size,
      })
        .then(data => {
          this.tableDataList = data.records
          this.total = parseInt(data.total)
        })
        .catch(error => {
          console.error(error)
        })
    },
    getDataMap () {
      try {
        request('getArea', {
          parentId: 1
        }).then(data => {
          this.provinceList = data
        })
        request('getRobotStatusMap').then(data => {
          this.robotStatusList = data
        })
        request('getIndustryList').then(data => {
          this.industryList = data
        })
      } catch (error) {
        console.log(error)
      }
    },
    searchData (data) {
      this.query = data
      this.getData()
    },
    updatePage (page, size) {
      this.page = page || 1
      this.size = size || 10
      this.getData()
    },
    handleClick (row) {
      this.$router.push({
        path: '/collect/healthScoreTrend',
        query: { robotSn: row.robotSn }
      })
    },
    // 下载报文  
    async exportReportData (row) {
      try {
        const res = await downloadFile("collectReportDownload", {}, {
          method: 'GET',
          params: { id: row.id }
        });
        // let blob = new Blob([res],{type: "application/octet-stream"})
        let reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = row.decodeFileName
          a.href = e.target.result
          a.click()
        }
      } catch (error) {
        console.error(error)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.progress-text {
  font-size: 12px;
}
</style>
